// extracted by mini-css-extract-plugin
export default {"product_card":"ProductCard_product_card__UkwJj","product_price":"ProductCard_product_price__XWc+6","product_description":"ProductCard_product_description__5rdAZ"};